import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {observable} from 'mobx';

export class SurfaceFileUploadState
{
    @observable
    public instances:Map<UploadId, UploadInstance> = new Map();

    @observable
    public isFileDraggingOverSurface:boolean = false;

    @observable
    public isFileDraggingOverPropertiesPanel:boolean = false;
}

export type UploadId = GUID;

export enum UploadStatus
{
    Uploading = 'Uploading',
    UploadFailed = 'UploadFailed',
    UploadSuccess = 'UploadSuccess',
    UploadCancelled = 'UploadCancelled',
}

export enum UploadFailedReasonEnum
{
    MultipleIsNotAllowed = 'MultipleIsNotAllowed',
    FileTypeIsNotSupported = 'FileTypeIsNotSupported'
}

export type UploadFailedReason = UploadFailedReasonEnum | string;

export class UploadInstance
{
    public readonly id:UploadId;

    public readonly file:File;

    @observable
    public status:UploadStatus;

    @observable
    public failedReason:UploadFailedReason;

    @observable
    public uploadProgress:number = 0; // [0...100]

    @observable
    public uploadedFileUrl:string;

    public constructor(file:File,
                       status:UploadStatus,
                       failedReason?:UploadFailedReason)
    {
        this.id = IdUtil.newGUID();

        this.file = file;
        this.status = status;
        this.failedReason = failedReason;
    }

    public get isUploading():boolean
    {
        return this.status === UploadStatus.Uploading;
    }

    public get isUploadFailed():boolean
    {
        return this.status === UploadStatus.UploadFailed;
    }

    public get isUploadSuccess():boolean
    {
        return this.status === UploadStatus.UploadSuccess;
    }

    public get isUploadCancelled():boolean
    {
        return this.status === UploadStatus.UploadCancelled;
    }
}
